import { render, staticRenderFns } from "./form-date.vue?vue&type=template&id=5659bffa&"
import script from "./form-date.vue?vue&type=script&lang=js&"
export * from "./form-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-date.vue"
export default component.exports